export default __webpack_public_path__ + "static/media/Shreyash_Choppawar.070b09fc.jpg";